export const APP_DETAILS = {
  name: "SQL RUNNER ONLINE",
};
